import { Store } from 'redux';

import { IAnyActionComposerMap, composeInitialState, composeModule } from './composeActions';
import { combineModuleInitialStates, createStoreWithModules } from './createStore';
import { dispatch, setDispatch } from './dispatch';
import { IModule } from './types';

export function linkStoreAndView<P, T, S extends IAnyActionComposerMap<T>>(
  store: Store,
  modules: IModule<P, T, S>[],
  renderer?
) {
  setDispatch(store.dispatch);

  if (renderer) {
    renderer(store);
  }

  dispatch({ type: 'APP_INITIALIZED' });
  return store;
}

export function composeApp<P, T, S extends IAnyActionComposerMap<T>>(
  modules: IModule<P, T, S>[],
  renderer?: (store: Store) => void
) {
  return linkStoreAndView(createStoreWithModules(modules), modules, renderer);
}

export { dispatch, setDispatch, combineModuleInitialStates, composeModule, composeInitialState };
